import React, {useState} from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import "./PropertyPermitInfo.scss";

const PropertyPermitInfo = ({ qrUrl, permitNumber }) => {
    const [showInfo, setShowInfo] = useState(false);
    const handleInfoClick = () => {
      setShowInfo(!showInfo);
    };

  return (
    <Container>
      <div className="permit-info-wrap">
        <h5 className="heading">Property Permit Information</h5>
        <Row>
          <Col xs="auto" className="qr-image">
            <img
              src={qrUrl}
              alt="QR Code"
              className="img-fluid"
            />
          </Col>
          <Col className="permit-info">
            <h6 className="permit-title">Permit Number: <span onClick={handleInfoClick} className="info-icon"><i className="icon-permit-info"></i></span></h6>
            <p className="permit-number">{permitNumber}</p>
            {showInfo && (<p className="permit-text">
              This property listing has been reviewed and verified by Dubai Land Department.
            </p>)}
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default PropertyPermitInfo;